import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Risorse di traduzione
const resources = {
  it: {
    translation: {
      // Navigazione principale
      nav: {
        home: 'Home',
        shops: 'Negozi',
        cart: 'Carrello',
        profile: 'Profilo'
      },
      
      // Pagina Home
      home: {
        featured_shops: 'Negozi in Evidenza',
        promotions: 'Promozioni',
        special_offer: 'Offerta Speciale',
        discount_message: 'Sconto del 20% su tutti i prodotti questo weekend!',
        welcome: 'Benvenuto',
        explore_shops: 'Esplora i Negozi'
      },
      
      // Ricerca
      search: {
        products_shops: 'Cerca prodotti o negozi...',
        no_results: 'Nessun risultato trovato',
        recent_searches: 'Ricerche recenti'
      },
      
      // Pagina Shop
      shop: {
        all_shops: 'Tutti i Negozi',
        search_placeholder: 'Cerca un negozio...',
        categories: 'Categorie',
        popular: 'Popolari',
        newest: 'Nuovi',
        view_shop: 'Vedi Negozio',
        no_shops_found: 'Nessun negozio trovato'
      },
      
      // Pagina Checkout
      checkout: {
        your_cart: 'Il tuo Carrello',
        empty_cart: 'Il tuo carrello è vuoto',
        start_shopping: 'Inizia lo Shopping',
        total: 'Totale',
        proceed_to_payment: 'Procedi al Pagamento',
        item: 'Articolo',
        items: 'Articoli',
        remove: 'Rimuovi',
        quantity: 'Quantità',
        summary: 'Riepilogo Ordine',
        subtotal: 'Subtotale',
        shipping: 'Spedizione',
        discount: 'Sconto',
        promo_code: 'Codice Promozionale',
        apply: 'Applica'
      },
      
      // Pagina Profilo
      profile: {
        edit_profile: 'Modifica Profilo',
        delivery_address: 'Indirizzo di Consegna',
        my_orders: 'I miei Ordini',
        wishlist: 'Lista Desideri',
        payment_methods: 'Metodi di Pagamento',
        logout: 'Logout',
        personal_info: 'Informazioni Personali',
        change_password: 'Cambia Password',
        notifications: 'Notifiche',
        language: 'Lingua',
        support: 'Supporto',
        privacy: 'Privacy',
        name: 'Nome',
        phone: 'Numero telefonico',
        region: 'Regione',
        avatar_upload: 'Carica immagine profilo',
        saved: 'Profilo aggiornato!'
      },
      
      // Pagina Prodotto
      product: {
        description: 'Descrizione',
        sizes: 'Taglie',
        colors: 'Colori',
        add_to_cart: 'Aggiungi al Carrello',
        add_to_wishlist: 'Aggiungi alla Lista Desideri',
        reviews: 'Recensioni',
        related_products: 'Prodotti Correlati',
        specifications: 'Specifiche',
        availability: 'Disponibilità',
        in_stock: 'Disponibile',
        out_of_stock: 'Esaurito',
        select_size: 'Seleziona la taglia',
        select_color: 'Seleziona il colore'
      },
      
      // Messaggi comuni
      common: {
        error: 'Errore',
        success: 'Successo',
        loading: 'Caricamento...',
        confirm: 'Conferma',
        cancel: 'Annulla',
        save: 'Salva',
        delete: 'Elimina',
        edit: 'Modifica',
        back: 'Indietro',
        next: 'Avanti'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'it',
    interpolation: {
      escapeValue: false // non necessario per React
    }
  });

export default i18n; 